// External libraries
import gql from 'graphql-tag';

export const SUPPORTED_FUNDING_SOUCRES_QUERY = gql`
  query SupportedFundingSourcesQuery(
    $token: String!
    $userCountry: CountryCodes
  ) {
    checkoutSession(token: $token) {
      supportedFundingSources(userCountry: $userCountry) {
        issuers {
          name
          usage
          issuerLogoUrl {
            href
          }
          rank
        }
      }
    }
  }
`;
